<template>
    <b-card
        no-body
        border-variant="light"
    >
        <div class="card-header">
            <div class="col-md-6 pl-0">
                <b-card-title>{{ $t('Page(SendRequest):Component(Label):email') }}</b-card-title>
            </div>
            <div class="col-md-6 pr-0">
            </div>
        </div>
        <div class="pl-2 pr-2 pb-2">
            <b-form-group
                :label="$t('Page(SendRequest):Component(Label):email-subject')"
                label-for="subject"
            >
                <b-form-input
                    disabled
                    id="subject"
                    placeholder="Subject"
                    v-model="email.subject"
                />
            </b-form-group>
            <b-form-group
                :label="$t('Page(SendRequest):Component(Label):email-message')"
                label-for="message"
            >
                <p class="pt-1">
                    Dear Supplier at {{ supplier }}
                    <br>
                    <br>
                    As a business operating within the European market, including EU member states, Lichtenstein, Norway, and Iceland, we are required to comply with stringent chemical legislation.
                    <br>
                    This includes compliance with the REACH Regulation (EC) No 1907/2006 and the EU Waste Framework Directive (EU) 2018/851. The latter mandates that supply chain actors report data on Substances of Very High Concern (SVHC) to the ECHA SCIP-database.
                    <br>
                    <br>
                    To comply with these legal requirements, we need to verify that the products we procure from you meet these requirements.
                    <br>
                    Therefore, we request that you <u>actively provide information</u> on any SVHC substances present in the products you supply.
                    <br>
                    <br>
                    To assist you in this process, we have implemented Chemity, a software developed by regulatory and technical experts designed to streamline compliance reporting.
                    <br>
                    As our valued supplier, you have access to a <u>free limited account</u>, which allows you to respond directly to our inquiries and, if necessary, forward the request to your suppliers to gather detailed substance information.
                    <br>
                    This platform ensures complete confidentiality regarding supply chain and sensitive product data.
                    <br>
                    <br>
                    <b>Please <u><a href="javascript:;" style="color: #4c7c8a;">click here</a></u> to access your account and respond to our request for information.</b>
                    <br>
                    <br>
                    For additional details about the Chemity tool, visit Chemity’s website at <a href="https://www.chemity.eu" style="color: #4c7c8a;">www.chemity.eu</a>.
                    <br>
                    If you are currently using another software tool for product compliance, please contact Chemity at <a href="mailto:info@chemity.eu" style="color: #4c7c8a;">info@chemity.eu</a> for assistance with bulk information transfers.
                    <br>
                    <br>
                    If you have any questions regarding our request for information, please don’t hesitate to contact me.
                    <br>
                    <br>
                    Thank you for your cooperation and prompt attention to this matter.
                    <br>
                    <br>
                    Best Regards,
                    <br>
                    <br>
                    {{ $store.getters.profile.name }}
                    <br>
                    {{ $store.getters.subscriber.title }}
                    <br>
                </p>
            </b-form-group>
        </div>
    </b-card>
</template>

<script>
import { BFormInput, BCardTitle, BCard, BFormGroup, BListGroup, BFormTextarea } from 'bootstrap-vue'

export default {
    components: {
        BFormInput, BCardTitle, BCard, BFormGroup, BListGroup, BFormTextarea,
    },
    props: {
        supplierNameDefault: {
            type: String,
            default: '{suppliers name will replace this text}'
        },
        supplierName: {
            default: null
        }
    },
    data() {
        return {
            email: {
                subject: 'Request for information on substances in articles',
            },
        };
    },
    computed: {
        supplier() {
            return this.supplierName || this.supplierNameDefault;
        }
    }
}
</script>
